export class ExtQueryCriteria {
  param_code: string;
  value_string: string;
  value_numeric: number;
}
